import { render, staticRenderFns } from "./AddTimedNotification.vue?vue&type=template&id=4a4843c4&scoped=true&"
import script from "./AddTimedNotification.vue?vue&type=script&lang=js&"
export * from "./AddTimedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4843c4",
  null
  
)

export default component.exports